import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Trending from './components/Trending';
import CategoryFeed from './components/CategoryFeed';
import LoveLine from './components/LoveLine';
import Poll from './components/Poll';
import About from './components/About';
import Faq from './components/Faq';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
        show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'
      }`}
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <Trending />
        <CategoryFeed />
        <LoveLine />
        <Poll />
        <About />
        <Faq />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}